const tokensEN = {
    "view": {
        "title": "Tokens History",
        "table": {
            "column": {
                "quantity": "Quantity",
                "description": "Description",
                "type": "Type",
                "balance": "Balance",
                "date": "Date",
                "receipt": "Receipt"
            },
            "placeholder": {
                "search": "Search..."
            },
            "button": {
                "view": "View",
                "export_csv": "Export CSV",
                "order_tokens": "Order Tokens"
            },
            "label": {
                "not_available": "Not Available",
                "credit": "Credit",
                "debit": "Debit"
            }
        }
    },
    "order": {
        "title": "Order Tokens",
        "form": {
            "label": {
                "quantity": "Quantity"
            },
            "placeholder": {
                "quantity": "Select Quantity"
            },
            "help": {
                "quantity": "Amount of tokens that you want to order."
            },
            "validation": {
                "quantityRequired": "Quantity is required"
            },
            "button": {
                "placeOrder": "Place Order"
            },
            "option": {
                "tokensAmount": "{{count}} Tokens"
            }
        },
        "modal": {
            "title": "Proceed to checkout",
            "orderedPrefix": "You have ordered",
            "description": "If you want to confirm the order please proceed to checkout, otherwise you can cancel the order.",
            "button": {
                "cancel": "Cancel",
                "checkout": "Checkout"
            }
        },
        "message": {
            "error": "Something went wrong! Please refresh page and try again!"
        }
    },
    "transaction": {
        "success": {
            "title": "Transaction Successful :)",
            "description": "You have successfully purchased the tokens which will be shortly added to your account!"
        },
        "cancel": {
            "title": "Transaction Cancelled :(",
            "description": "The transaction was cancelled... Please try again later!"
        },
        "button": {
            "returnToDashboard": "Return to Dashboard"
        }
    }
};

export default tokensEN;
